import React from "react";
import { Field, ConfigInput } from "./Field";

export function S3Fields({ config, setConfig }) {
  return (
    <>
      <Field label="Bucket" required>
        <ConfigInput name="bucket" config={config} setConfig={setConfig}
          testId="dest-bucket" required />
      </Field>
      <Field label="Region" required>
        <ConfigInput name="region" config={config} setConfig={setConfig} required />
      </Field>
      <Field label="Access key ID" required>
        <ConfigInput name="access_key_id" config={config} setConfig={setConfig}
          testId="dest-access-key" required />
      </Field>
      <Field label="Secret access key" required>
        <ConfigInput name="secret_access_key" config={config} setConfig={setConfig}
          testId="dest-secret-key" required type="password" />
      </Field>
      <Field label="Key prefix (optional)" colSpan={2}>
        <ConfigInput name="prefix" config={config} setConfig={setConfig}
          placeholder="leadflow/incoming/" />
      </Field>
    </>
  );
}

export function FtpFields({ config, setConfig }) {
  return (
    <>
      <Field label="Host" required>
        <ConfigInput name="host" config={config} setConfig={setConfig} testId="dest-host" required />
      </Field>
      <Field label="Port">
        <ConfigInput name="port" config={config} setConfig={setConfig} type="number" />
      </Field>
      <Field label="Username" required>
        <ConfigInput name="username" config={config} setConfig={setConfig} required />
      </Field>
      <Field label="Password" required>
        <ConfigInput name="password" config={config} setConfig={setConfig} required type="password" />
      </Field>
      <Field label="Directory (optional)" colSpan={2}>
        <ConfigInput name="directory" config={config} setConfig={setConfig}
          placeholder="/leads/incoming" />
      </Field>
      <div className="col-span-2 inline-flex items-center gap-2">
        <input type="checkbox" checked={!!config.use_tls} data-testid="dest-use-tls"
          onChange={(e) => setConfig("use_tls", e.target.checked)}
          className="border-2 border-black h-4 w-4" />
        <span className="text-[11px] uppercase tracking-widest">Use FTPS (explicit TLS)</span>
      </div>
    </>
  );
}
